'use strict';

module.exports = /*@ngInject*/ ['$rootScope', '$injector',
function ConfigurationStoreService($rootScope, $injector) {
    this.projectConfigurations = {};
    this.trainTypeConfigurations = {}; 

    this.setProjectConfiguration = setProjectConfiguration;
    this.getProjectConfiguration = getProjectConfiguration;

    this.setTrainTypeConfiguration = setTrainTypeConfiguration;
    this.getTrainTypeConfiguration = getTrainTypeConfiguration;

    function setProjectConfiguration(projectId, configuration) {
        this.projectConfigurations[projectId] = configuration;
        $rootScope.$emit('project-config-updated');
        $injector.get('projectConfigurationBehaviorSubjectService').inform(null);
    }

    function setTrainTypeConfiguration(projectId, configuration) {
        var trainType = configuration.type;
        if (trainType) {
            if (!this.trainTypeConfigurations[projectId]) {
                this.trainTypeConfigurations[projectId] = {};
            }
            this.trainTypeConfigurations[projectId][trainType] = configuration;
            $rootScope.$emit('train-type-config-updated');
        }
    }

    function getProjectConfiguration(projectId) {
        return this.projectConfigurations[projectId];
    }

    function getTrainTypeConfiguration(projectId, trainType) {
        return this.trainTypeConfigurations[projectId] && this.trainTypeConfigurations[projectId][trainType];
    }

}];